import React from 'react';
import { Box, FormControl, MenuItem, Select } from '@mui/material';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import { MARKETS, MARKET_CODES, useMarket } from '../lib/market';

const SHORT = { IN: 'IN', US: 'US', OTHER: 'All' };

/**
 * The country menu in the bar of the public pages. It decides the currency prices are written in and the country a new candidate's
 * job search opens on (lib/market.js). It starts on the country the browser's language says and keeps what the visitor picks.
 */
const CountrySelect = () => {
  const { code, choose } = useMarket();
  return (
    <FormControl size="small" sx={{ flexShrink: 0 }}>
      <Select
        value={code}
        onChange={(event) => choose(event.target.value)}
        inputProps={{ 'aria-label': 'Country' }}
        // On a phone the bar has no room for a name, so it shows the short code; the list always shows the name.
        renderValue={(value) => (
          <>
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' }, whiteSpace: 'nowrap' }}>{MARKETS[value].label}</Box>
            <Box component="span" aria-hidden sx={{ display: { xs: 'inline', sm: 'none' } }}>{SHORT[value]}</Box>
          </>
        )}
        data-testid="country-select"
        startAdornment={<PublicOutlinedIcon fontSize="small" sx={{ mr: 0.75, opacity: 0.8, display: { xs: 'none', sm: 'block' } }} />}
        sx={{
          color: 'inherit', fontSize: '0.875rem', borderRadius: 999,
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' },
          '& .MuiSelect-icon': { color: 'inherit' },
          '& .MuiSelect-select': { py: 0.75, pr: '28px !important', pl: { xs: 1.5, sm: 0 } },
        }}
      >
        {MARKET_CODES.map((marketCode) => <MenuItem key={marketCode} value={marketCode}>{MARKETS[marketCode].label}</MenuItem>)}
      </Select>
    </FormControl>
  );
};

export default CountrySelect;
